import { createStyles } from "@material-ui/core";

export const useStyles = (theme) => createStyles({});
